/**
 * Numéro de portable lisible, tel qu'on le dicte.
 *
 * Le serveur garde le numéro au format international compact (« +41795551267 ») :
 * c'est ce qu'attend le prestataire SMS, mais à l'écran on le relit mal. Les
 * numéros suisses et français prennent leur découpage habituel ; un autre
 * numéro garde son indicatif à part et se lit par groupes de trois.
 *
 * @param {string} [numero] numéro tel que le serveur le rend
 * @returns {string} le numéro découpé, ou tel quel s'il n'est pas reconnu
 */
export function numeroLisible(numero) {
  const brut = String(numero ?? '').trim();
  const suisse = brut.match(/^\+41(\d{2})(\d{3})(\d{2})(\d{2})$/);
  if (suisse) return `+41 ${suisse.slice(1).join(' ')}`;
  const francais = brut.match(/^\+33(\d)(\d{2})(\d{2})(\d{2})(\d{2})$/);
  if (francais) return `+33 ${francais.slice(1).join(' ')}`;
  const autre = brut.match(/^\+(\d{2})(\d{6,13})$/);
  if (autre) return `+${autre[1]} ${autre[2].match(/\d{1,3}/g).join(' ')}`;
  return brut;
}
